import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { baseURL } from "../Constant";
export const VivaSlice = createSlice({
 name: "viva",
 initialState: {
  error: false,

  mailData: "",
  mailDataReminder: "",
  mailDataNudge: "",
  mailDataRecognition: "",
  isVivaLoaded: false,
  isVivaLoadedReminder: false,
  isVivaLoadedNudge: false,
  isVivaLoadedRecognition: false,
  programDetails: [],
 },
 reducers: {
  setMail: (state, { payload }) => {
   state.mailData = payload;
   state.isVivaLoaded = true;
  },
  setMailReminder: (state, { payload }) => {
   state.mailDataReminder = payload;
   state.isVivaLoadedReminder = true;
  },
  setMailRecognition: (state, { payload }) => {
   state.mailDataRecognition = payload;
   state.isVivaLoadedRecognition = true;
  },
  setMailNudge: (state, { payload }) => {
   state.mailDataNudge = payload;
   state.isVivaLoadedNudge = true;
  },

  setProgramDetails: (state, { payload }) => {
   state.programDetails = payload;
  },
  setError: (state) => {
   state.error = true;
  },

  setMailLoad: (state) => {
   state.isVivaLoaded = false;
  },
  setMailLoadReminder: (state) => {
   state.isVivaLoadedReminder = false;
  },

  setMailLoadRecognition: (state) => {
   state.isVivaLoadedRecognition = false;
  },

  setMailLoadNudge: (state) => {
   state.isVivaLoadedNudge = false;
  },
 },
});

// Action creators are generated for each case reducer function
export const {
 setError,
 setMail,
 setMailLoad,
 setProgramDetails,
 setMailReminder,
 setMailNudge,
 setMailLoadReminder,
 setMailLoadNudge,
 setMailLoadRecognition,
 setMailRecognition,
} = VivaSlice.actions;

export default VivaSlice.reducer;

export function handleGenerateViva(values) {
 return (dispatch) => {
  axios
   .post(`${baseURL}/vivaLaunch/fetchResponse`, { values })
   .then((response) => {
    // then print response status
    dispatch(setMail(response.data));
   })
   .catch((err) => {
    // then print response status
    // console.error("fetch fail", err);
   });
 };
}
export function handleGenerateVivaNewContent(values) {
 return (dispatch) => {
  axios
   .post(`${baseURL}/vivaLaunchNewContent/fetchResponse`, { values })
   .then((response) => {
    // then print response status
    dispatch(setMail(response.data));
   })
   .catch((err) => {
    // then print response status
    // console.error("fetch fail", err);
   });
 };
}
export function handleGenerateVivaReminder(values) {
 return (dispatch) => {
  axios
   .post(`${baseURL}/vivaReminder/fetchResponse`, { values })
   .then((response) => {
    // then print response status
    dispatch(setMailReminder(response.data));
   })
   .catch((err) => {
    // then print response status
    // console.error("fetch fail", err);
   });
 };
}
export function handleGenerateVivaReminderNewContent(values) {
 return (dispatch) => {
  axios
   .post(`${baseURL}/vivaReminderNewContent/fetchResponse`, { values })
   .then((response) => {
    // then print response status
    dispatch(setMailReminder(response.data));
   })
   .catch((err) => {
    // then print response status
    // console.error("fetch fail", err);
   });
 };
}
export function handleGenerateVivaRecognition(values) {
 return (dispatch) => {
  axios
   .post(`${baseURL}/vivaRecognition/fetchResponse`, { values })
   .then((response) => {
    // then print response status
    dispatch(setMailRecognition(response.data));
   })
   .catch((err) => {
    // then print response status
    // console.error("fetch fail", err);
   });
 };
}
export function handleGenerateVivaRecognitionNewContent(values) {
 return (dispatch) => {
  axios
   .post(`${baseURL}/vivaRecognitionNewContent/fetchResponse`, { values })
   .then((response) => {
    // then print response status
    dispatch(setMailRecognition(response.data));
   })
   .catch((err) => {
    // then print response status
    // console.error("fetch fail", err);
   });
 };
}
export function handleGenerateVivaNudge(values) {
 return (dispatch) => {
  axios
   .post(`${baseURL}/vivaNudge/fetchResponse`, { values })
   .then((response) => {
    // then print response status
    dispatch(setMailNudge(response.data));
   })
   .catch((err) => {
    // then print response status
    // console.error("fetch fail", err);
   });
 };
}
export function handleGenerateVivaNudgeNewContent(values) {
 return (dispatch) => {
  axios
   .post(`${baseURL}/vivaNudgeNewContent/fetchResponse`, { values })
   .then((response) => {
    // then print response status
    dispatch(setMailNudge(response.data));
   })
   .catch((err) => {
    // then print response status
    // console.error("fetch fail", err);
   });
 };
}

export function handleVivaLoading() {
 console.log("bcbs");
 return (dispatch) => {
  dispatch(setMailLoad());
 };
}
export function handleVivaLoadingReminder() {
 console.log("bcbs");
 return (dispatch) => {
  dispatch(setMailLoadReminder());
 };
}

export function handleVivaLoadingNudge() {
 console.log("bcbs");
 return (dispatch) => {
  dispatch(setMailLoadNudge());
 };
}
export function handleVivaLoadingRecognition() {
 console.log("bcbs");
 return (dispatch) => {
  dispatch(setMailLoadRecognition());
 };
}
export function handleFetchProgramNames(campaignID, mailerChild) {
 return (dispatch) => {
  axios
   .post(`${baseURL}/fetchProgramData`, { campaignID, mailerChild })
   .then((response) => {
    // then print response status
    dispatch(setProgramDetails(response.data));
   })
   .catch((err) => {
    // then print response status
    // console.error("fetch fail", err);
   });
 };
}
export function fetchNonCampignMails(mailtype, category) {
 return (dispatch) => {
  axios
   .post(`${baseURL}/fetchNonCampignMails`, { mailtype, category })
   .then((response) => {
    dispatch(setProgramDetails(response.data));
   })
   .catch((err) => {
    // then print response status
    // console.error("fetch fail", err);
   });
 };
}
